import { HttpParams, HttpUrlEncodingCodec } from "@angular/common/http";

export default class HttpParamsHelper {
  static convertToHttpParams(model: any): HttpParams {
    // Use custom encoder to preserve special characters as "+"
    let params = new HttpParams({ encoder: new HttpUrlEncodingCodec() });

    Object.keys(model).forEach(key => {
      const value = model[key];

      if (value instanceof Array) {
        value.forEach((value: any) => params = params.append(key, value.toString()));
      }
      else if (value instanceof Date) {
        const date: Date = value as Date;
        params = params.set(key, date.toISOString());
      }
      else if (value instanceof Object) {
        params = params.set(key, JSON.stringify(value));
      }
      else if (value || value === false) {
        params = params.set(key, value.toString());
      }
    });

    return params;
  }
}
